// Drives /admin/content/generate: dropzone feedback and a submit gate
// so the form can't post without a file. Without JS the button stays
// enabled and the server validates.

import { formatBytes } from "./presentation_tus.js";
import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

const ROOT_SELECTOR = "[data-generate-source]";

export function initAdminGenerateSource(root = document) {
  if (!root.querySelectorAll) return;
  root.querySelectorAll(ROOT_SELECTOR).forEach(wireWidget);
}

function wireWidget(widget) {
  if (!firstBind(widget)) return;

  const fileInput = widget.querySelector("[data-source-input]");
  const dropzone = widget.querySelector("[data-source-dropzone]");
  const empty = widget.querySelector("[data-source-empty]");
  const selected = widget.querySelector("[data-source-selected]");
  const nameEl = widget.querySelector("[data-source-name]");
  const sizeEl = widget.querySelector("[data-source-size]");
  const submitBtn = widget.querySelector("[data-source-submit]");
  if (!fileInput) return;

  // A button the server rendered disabled is the concurrency gate held
  // shut. Read it before the first sync, and never reopen it — picking a
  // file would otherwise post into a 429.
  const locked = submitBtn?.disabled === true;

  const syncSubmit = () => {
    if (submitBtn) {
      submitBtn.disabled =
        locked || !(fileInput.files && fileInput.files.length);
    }
  };
  syncSubmit();

  fileInput.addEventListener("change", () => {
    const file = fileInput.files && fileInput.files[0];
    if (empty) empty.style.opacity = file ? "0" : "1";
    if (selected) selected.style.opacity = file ? "1" : "0";
    if (file) {
      if (nameEl) nameEl.textContent = file.name;
      if (sizeEl) sizeEl.textContent = formatBytes(file.size);
    }
    syncSubmit();
  });

  // The dropzone is the input's label, so plain clicks open the picker
  // natively — only drag and drop needs wiring.
  if (dropzone) {
    dropzone.addEventListener("dragenter", () => {
      dropzone.dataset.dragging = "true";
    });
    dropzone.addEventListener("dragover", (event) => event.preventDefault());
    dropzone.addEventListener("dragleave", (event) => {
      if (!dropzone.contains(event.relatedTarget)) {
        dropzone.dataset.dragging = "false";
      }
    });
    dropzone.addEventListener("drop", (event) => {
      event.preventDefault();
      dropzone.dataset.dragging = "false";
      const dt = event.dataTransfer;
      if (!dt || !dt.files || dt.files.length === 0) return;
      fileInput.files = dt.files;
      fileInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  const form = widget.querySelector("form");
  if (form) {
    form.addEventListener("submit", () => {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Starting…";
      }
    });
  }
}
